// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// src/scripts/fluco-lib/media-queries.js
function getMediaQuery(querySize) {
  const value = getComputedStyle(document.body).getPropertyValue(
    `--fluco-js-${querySize}`
  );
  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }
  return value;
}
function checkMediaQuery(querySize) {
  const mediaQuery = getMediaQuery(querySize);
  return window.matchMedia(mediaQuery).matches;
}

// src/scripts/fluco-lib/countdown.js
var MultipleCountdownTimerGroup = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      sectionInner: "[js-section-inner]",
      activeContentBlock: "[js-active-content-block]",
      activeTimer: "[js-active-timer]",
      timerContainerDesktop: "[js-timer-container-desktop]",
      timerContainerMobile: "[js-timer-container-mobile]"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.sectionInnerEl = this.closest(this.selectors.sectionInner);
    window.requestAnimationFrame(this.setTimerPlacement.bind(this));
    window.addEventListener("resize", this.setTimerPlacement.bind(this), {
      passive: true,
      signal: this.eventController.signal
    });
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  setTimerPlacement() {
    this.activeContentBlock = this.querySelector(
      this.selectors.activeContentBlock
    );
    this.timerContainerDesktop = this.activeContentBlock.querySelector(
      this.selectors.timerContainerDesktop
    );
    this.timerContainerMobile = this.activeContentBlock.querySelector(
      this.selectors.timerContainerMobile
    );
    const activeTimer = this.activeContentBlock.querySelector(
      this.selectors.activeTimer
    );
    const isMobile = checkMediaQuery("mobile");
    let targetContainer;
    if (isMobile) {
      targetContainer = this.timerContainerMobile;
    } else {
      targetContainer = this.timerContainerDesktop;
    }
    if (activeTimer && targetContainer && activeTimer.parentNode !== targetContainer) {
      targetContainer.innerHTML = "";
      targetContainer.appendChild(activeTimer);
    }
  }
};
if (!customElements.get("fluco-multi-countdown-timer-group")) {
  customElements.define(
    "fluco-multi-countdown-timer-group",
    MultipleCountdownTimerGroup
  );
}
var CountdownTimer = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      sectionInner: "[js-section-inner]",
      days: "[js-days]",
      hours: "[js-hours]",
      minutes: "[js-minutes]",
      seconds: "[js-seconds]",
      timerGroup: "[js-timer-group]"
    };
  }
  connectedCallback() {
    this.sectionEl = this.closest(this.selectors.section);
    this.sectionInnerEl = this.closest(this.selectors.sectionInner);
    this.timerGroup = this.closest(this.selectors.timerGroup);
    this.daysEl = this.querySelector(this.selectors.days);
    this.hoursEl = this.querySelector(this.selectors.hours);
    this.minutesEl = this.querySelector(this.selectors.minutes);
    this.secondsEl = this.querySelector(this.selectors.seconds);
    this.timeZoneSelection = this.dataset.timeZoneSelection;
    this.shopTimeZoneOffset = this.dataset.shopTimeZoneOffset;
    let targetYear = parseInt(this.dataset.year, 10);
    if (targetYear > 9999) {
      targetYear = 2024;
    }
    const targetMonth = parseInt(this.dataset.month, 10) - 1;
    const targetDay = parseInt(this.dataset.day, 10);
    const targetHour = parseInt(this.dataset.hour, 10);
    const targetMinute = parseInt(this.dataset.minute, 10);
    let targetMS;
    if (this.timeZoneSelection === "shop" && this.shopTimeZoneOffset) {
      const offset = this.shopTimeZoneOffset;
      const sign = offset[0] === "+" ? 1 : -1;
      const hours = parseInt(offset.slice(1, 3), 10);
      const minutes = parseInt(offset.slice(3, 5), 10);
      const offsetMinutes = sign * (hours * 60 + minutes);
      targetMS = Date.UTC(targetYear, targetMonth, targetDay, targetHour, targetMinute) - offsetMinutes * 60 * 1e3;
    } else {
      targetMS = new Date(
        targetYear,
        targetMonth,
        targetDay,
        targetHour,
        targetMinute
      );
    }
    this.targetMS = targetMS;
    this.isComplete = false;
    this.timerInterval = setInterval(this.timerLoop.bind(this), 1e3);
    this.timerLoop();
    this.timerGroup.setAttribute("data-timer-state-checked", "true");
    this.timerGroup.setAttribute("data-timer-completed", "false");
  }
  timerLoop() {
    window.requestAnimationFrame(this.updateCountdown.bind(this));
  }
  updateCountdown() {
    if (this.isComplete) return;
    const nowMS = (/* @__PURE__ */ new Date()).getTime();
    const differenceMS = this.targetMS - nowMS;
    const days = Math.floor(differenceMS / (1e3 * 60 * 60 * 24));
    const hours = Math.floor(
      differenceMS % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
    );
    const minutes = Math.floor(differenceMS % (1e3 * 60 * 60) / (1e3 * 60));
    const seconds = Math.floor(differenceMS % (1e3 * 60) / 1e3);
    if (differenceMS < 0) {
      this.timerInterval && clearInterval(this.timerInterval);
      this.daysEl.innerHTML = "0";
      this.hoursEl.innerHTML = this.minutesEl.innerHTML = this.secondsEl.innerHTML = "00";
      this.onComplete();
    } else {
      this.daysEl.innerHTML = days;
      this.hoursEl.innerHTML = `${hours}`.padStart(2, "0");
      this.minutesEl.innerHTML = `${minutes}`.padStart(2, "0");
      this.secondsEl.innerHTML = `${seconds}`.padStart(2, "0");
    }
  }
  onComplete() {
    this.setAttribute("data-timer-completed", "true");
    this.timerGroup.setAttribute("data-timer-completed", "true");
    this.isComplete = true;
    this.sectionEl.dispatchEvent(
      new Event(events_default.COUNTDOWN_TIMER_COMPLETED_EVENT)
    );
  }
  disconnectedCallback() {
    this.timerInterval && clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
};
if (!customElements.get("fluco-countdown-timer")) {
  customElements.define("fluco-countdown-timer", CountdownTimer);
}

// node_modules/srraf/dist/srraf.es.js
var n;
var e;
var i;
var o;
var t;
var r;
var f;
var d;
var p;
var u = [];
function w(n2, a) {
  return e = window.pageXOffset, o = window.pageYOffset, r = window.innerHeight, d = window.innerWidth, void 0 === i && (i = e), void 0 === t && (t = o), void 0 === p && (p = d), void 0 === f && (f = r), (a || o !== t || e !== i || r !== f || d !== p) && (!function(n3) {
    for (var w2 = 0; w2 < u.length; w2++) u[w2]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n3);
  }(n2), i = e, t = o, f = r, p = d), requestAnimationFrame(w);
}
function srraf_es_default(e2) {
  return u.indexOf(e2) < 0 && u.push(e2), n = n || w(performance.now()), { update: function() {
    return w(performance.now(), true), this;
  }, destroy: function() {
    u.splice(u.indexOf(e2), 1);
  } };
}

// src/scripts/fluco-lib/video-pair.js
var VideoPair = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      desktopVideo: "video.fluco-video--desktop",
      mobileVideo: "video.fluco-video--mobile"
    };
    this.classes = {};
    this.desktopBreakpoint = 720;
  }
  static observedAttributes = ["data-visible"];
  connectedCallback() {
    this.desktopVideo = this.querySelector(this.selectors.desktopVideo);
    this.mobileVideo = this.querySelector(this.selectors.mobileVideo);
    this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    this.aboveMobile = this.viewportWidth > this.desktopBreakpoint;
    if (this.aboveMobile) {
      if (this.desktopVideo) {
        this.desktopVideo.poster = this.desktopVideo.getAttribute("data-poster");
        const desktopVideoImg = this.desktopVideo.querySelector("img");
        if (desktopVideoImg) {
          desktopVideoImg.src = desktopVideoImg.getAttribute("data-src");
        }
      }
    }
    this.widthWatcher = srraf_es_default(({ vw, pvw }) => {
      if (vw === pvw) return;
      this.viewportWidth = vw;
      const nowAboveMobile = vw > this.desktopBreakpoint;
      if (nowAboveMobile !== this.aboveMobile) {
        this.aboveMobile = nowAboveMobile;
        this.swapToCorrectVideo();
      }
    });
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case "data-visible":
        if (newValue === "true") {
          this.playVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        } else {
          this.pauseVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        }
        break;
    }
  }
  swapToCorrectVideo() {
    if (this.aboveMobile) {
      this.pauseVideo(this.mobileVideo);
      this.loadVideo(this.desktopVideo);
      this.playVideo(this.desktopVideo);
    } else {
      this.pauseVideo(this.desktopVideo);
      this.loadVideo(this.mobileVideo);
      this.playVideo(this.mobileVideo);
    }
  }
  loadVideo(video) {
    if (!video) return;
    video.load();
  }
  playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.play();
  }
  pauseVideo(video) {
    if (!video) return;
    video.pause();
  }
};
if (!customElements.get("fluco-video-pair")) {
  customElements.define("fluco-video-pair", VideoPair);
}

// src/scripts/sections/section-countdown.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var CountdownSection = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      timerGroup: "[js-timer-group]",
      completedContentBlock: "[js-completed-content-block]"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.sectionEl = this.closest(this.selectors.section);
    this.timerGroup = this.querySelector(this.selectors.timerGroup);
    this.completedContentBlock = this.querySelector(
      this.selectors.completedContentBlock
    );
    if (window.Shopify.designMode) {
      this.setAttribute("data-theme-editor", "true");
      this.sectionEl.addEventListener(
        SHOPIFY_BLOCK_SELECT,
        (event) => this.handleBlockSelected(event.detail.blockId),
        this.eventOptions
      );
      this.sectionEl.addEventListener(
        SHOPIFY_BLOCK_DESELECT,
        (event) => this.handleBlockDeselected(event.detail.blockId),
        this.eventOptions
      );
    }
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  handleBlockSelected(blockId) {
    if (this.completedContentBlock && this.completedContentBlock.getAttribute("data-block-id") === blockId && this.timerGroup.getAttribute("data-replace-content-when-completed") === "true") {
      this.timerGroup.setAttribute("data-editor-content-override", "true");
    }
  }
  handleBlockDeselected(blockId) {
    if (this.completedContentBlock.getAttribute("data-block-id") === blockId) {
      this.timerGroup.setAttribute("data-editor-content-override", "false");
    }
  }
};
if (!customElements.get("fluco-countdown-section")) {
  customElements.define("fluco-countdown-section", CountdownSection);
}
